<template>
  <div>
    <h3 >Welcome {{currentUser}}</h3>
    <v-container>
      <v-row justify="center">
        <!-- <v-col md="4" xs="12">
          <router-link to="/Gallery">
            <div class="dashboard">
              <h3>Gallery</h3>
            </div>
          </router-link>
        </v-col> -->
        <!-- <v-col md="3" xs="12">
          <router-link to="/Manufacture">
            <div class="dashboard">
              <h3>Infrastructure</h3>
            </div>
          </router-link>
        </v-col> -->

        <v-col md="3" xs="12">
          <router-link to="/Customers">
            <div class="dashboard">
              <h4>Clients</h4>
            </div>
          </router-link>
        </v-col>
          <v-col md="3" xs="12">
          <router-link to="/broucher">
            <div class="dashboard">
              <h4>Broucher</h4>
            </div>
          </router-link>
        </v-col>
        <v-col md="3" xs="12">
          <router-link to="/testimonials">
            <div class="dashboard">
              <h4>Testimonials</h4>
            </div>
          </router-link>
        </v-col>
        <v-col md="3" xs="12">
          <router-link to="/certificates">
            <div class="dashboard">
              <h4>Certificates</h4>
            </div>
          </router-link>
        </v-col>
        <v-col md="3" xs="12">
          <router-link to="/Product">
            <div class="dashboard">
              <h4>Products</h4>
            </div>
          </router-link>
        </v-col>
        
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { fb } from "../firebase";
export default {
  name: "Dashboard",
  data: () => ({
    currentUser: "",
  }),
  created() {
    if (fb.auth().currentUser) {
      this.currentUser = fb.auth().currentUser.email;
    }
  },
};
</script>
<style>
.dashboard {
    margin: 30px 0;
    align-items: center;
    cursor: pointer;
    padding: 20px;
    background-color: rgb(192, 188, 188);
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
    border-radius: 15px;
    text-align: center;
    overflow: hidden;
    color: white;
    position: relative;
    display: block;
    height: 100px;
    margin-top: 30px;
    /* transition-delay: 0.1s; */
    transition-duration: 0.5s;
    transition-property: transform;
    width: 200px;
}


.dashboard:hover {
  color: #fff;
  transform: translateY(-15px);

  cursor: pointer;
}
h4{
  color: #050674;
  text-align: center;
}
h3 {
    color: #050674;
    text-align: center;
    font-size: 24px;
    margin: 30px;
}
a {
  color: #ffffff;
  margin-bottom: 15px;
  margin-top: 20px;
  display: block;
  overflow: hidden;
  transition: 1.5s;
  text-decoration: none;
}
a:hover {
  text-decoration: none;
}
</style>
